import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    CalendarSurfaceOptions,
    getDefaultOptions,
} from 'owa-outlook-service-options';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getNumDaysInDayRange(): number {
    if (!isFeatureEnabled('cal-showSingleDayViewWithMultiDaysSubMenu')) {
        return 1;
    }

    let numDaysInDayRange = 0;
    const userOptions = getOptionsForFeature<CalendarSurfaceOptions>(
        OwsOptionsFeatureType.CalendarSurfaceOptions
    );

    numDaysInDayRange = userOptions.numDaysInDayRange;

    // if numDaysInDayRange is zero, that means it has never been set before, in that case use the default value
    if (numDaysInDayRange == 0) {
        let defaultOptions = getDefaultOptions()[
            OwsOptionsFeatureType.CalendarSurfaceOptions
        ] as CalendarSurfaceOptions;
        numDaysInDayRange = defaultOptions.numDaysInDayRange;
    }
    return numDaysInDayRange;
}
